import { type FC } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { DeviceVariantSelectOption } from 'modules/it_management/components/DeviceVariantSelector/types'
import { F0Select } from '@factorialco/f0-react'
import { Keyboard } from '@factorialco/f0-react/icons/app'

export interface DeviceVariantSelectProps {
  variant: DeviceVariantSelectOption
  value?: string
  onChange: (value: string) => void
}

export const DeviceVariantSelect: FC<DeviceVariantSelectProps> = ({
  variant,
  value,
  onChange,
}) => {
  return (
    <Box flexDirection="column">
      <SectionHeader title={variant.title} description={''} />
      <Box flexDirection="column" gap="s8">
        <F0Select
          onChange={onChange}
          options={variant.variants.map((option) => {
            return {
              icon: Keyboard,
              label: option.name,
              value: option.id,
            }
          })}
          value={value}
        />
      </Box>
    </Box>
  )
}
